// extracted by mini-css-extract-plugin
module.exports =  {"lastUpdate":"aG_gb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"lastUpdate\":\"aG_gb\"}";
        // 1725548955100
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  